import * as d3 from 'd3'
import React from 'react'
import { useTheme } from 'styled-components'

// import { Container } from './styles';

const randomValue = (): number => Math.floor(Math.random() * 10)

export const Gauge: React.FC = () => {
    const theme = useTheme()
    const overviewCardGaugeScale = d3
        .scaleLinear<string>()
        .domain([0, 1, 2, 3, 4, 5, 6, 7, 8])
        .range(['#C70000', '#F55827', '#F6931D', '#F5D359', '#D6DE23', '#8CC63F', '#38B449', '#009344', '#007769'])

    return (
        <div style={{ width: 12, height: '100%' }}>
            <svg width={12} height={112} viewBox="0 0 12 112">
                {[...Array(9)].map((_, index) => (
                    <rect
                        key={index}
                        x={0}
                        y={((112 - 16) / 9 + 2) * index}
                        width={12}
                        height={(112 - 16) / 9}
                        fill={theme['gray-200']}
                    />
                ))}

                {[...Array(randomValue())].map((_, index, arr) => (
                    <rect
                        key={index}
                        x={0}
                        y={((112 - 16) / 9 + 2) * (8 - index)}
                        width={12}
                        height={(112 - 16) / 9}
                        fill={overviewCardGaugeScale(index)}
                    />
                ))}
            </svg>
        </div>
    )
}
